<template>
    <div class="">
        <div class="card-content fanGraphs">
        </div>
    </div>
</template>

<script>
    import {measurementShow} from "../../../measurementShow";

    export default {
        name: "FanGraphs",
        data() {
            return {
                watchLocked: false,
                obiekt: '',
                cadHeaderVisible: false,
                tescik: true,
                frequencyLock: 50,
                activeFanCount: 1,
            }
        },
        props: {
            offerView: {
                default: false
            }
        },
        computed: {
            detailsShowOryginalFrequency() {
                return this.$store.state.detailsShowOryginalFrequency;
            },
            fourthStepParamsLastUnitChanges() {
                return this.$store.state.fourthStepParamsLastUnitChanges.subId;
            },
        },
        watch: {
            detailsShowOryginalFrequency() {
                this.obiekt.calc();
            },
            fourthStepParamsLastUnitChanges() {
                if (this.$store.state.fourthStepParamsLastUnitChanges.userChanged && this.$store.state.fourthStepParamsLastUnitChanges.unit && this.$store.state.fourthStepParamsLastUnitChanges.unit.id) {

                    if (this.$store.state.ValueUnitMap.hasOwnProperty(this.$store.state.fourthStepParamsLastUnitChanges.unitType)) {
                        this.loadChangedUnit(this.$store.state.fourthStepParamsLastUnitChanges.unitType, this.$store.state.fourthStepParamsLastUnitChanges.unitType);
                    }
                }

                this.obiekt.calc();
            },
        },
        methods: {

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            openCadHeader() {
                this.cadHeaderVisible = !this.cadHeaderVisible;
            },

            calculateFans() {
                this.obiekt.refreshAxis();

                if (this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active) {
                    this.obiekt.refreshAllData(50);
                } else {
                    this.obiekt.refreshAllData(60);
                }

                this.obiekt.calc();
                this.obiekt.graphsSummary.draw();

                if (this.$store.state.selectedFan) {

                    this.$store.commit({
                        type: 'toggleAdjustResultBtn',
                        disabled: false
                    })
                }
            },
            loadChangedUnit(unitType, typeName) {
                if (this.$store.state.fourthStepParamsLastUnitChanges.param_id == unitType)
                    this.obiekt.graphsSummary.getUnitObject().selectUnitOfTypeName(typeName, this.$store.state.fourthStepParamsLastUnitChanges.unit.id);
            },
            manageReturnedData(returnedData, dataObject) {
                for (let value in returnedData) {
                    if (dataObject.hasOwnProperty(value))
                        dataObject[value] = returnedData[value];
                }

                this.checkChanges(dataObject);
            },
            checkChanges(obj) {
                if (!window.storeStates)
                    window.storeStates = [];

                let needChange = true;
                let needPushObject = true;

                for (let value in obj) {
                    if (isFinite(obj[value]))
                        obj[value] = parseFloat(obj[value]);
                }

                for (let i = 0; i < window.storeStates.length; i++) {
                    if (this.compareKeys(window.storeStates[i], obj)) {
                        needPushObject = false;

                        if (this.compareThisValue(window.storeStates[i], obj))
                            needChange = false;
                        else {
                            delete obj['this'];
                            window.storeStates[i] = obj;
                        }

                        break;
                    }
                }

                if (needPushObject) {
                    delete obj['this'];
                    window.storeStates.push(obj);
                }

                return needChange;
            },
            compareKeys(a, b) {
                let aKeys = Object.keys(a).sort();
                let bKeys = Object.keys(b).sort();
                aKeys.forEach((val, key) => {
                    val == "this" ? aKeys.splice(key, 1) : ""
                });
                bKeys.forEach((val, key) => {
                    val == "this" ? bKeys.splice(key, 1) : ""
                });

                return JSON.stringify(aKeys) === JSON.stringify(bKeys);
            },
            compare(a, b) {
                return JSON.stringify(a) === JSON.stringify(b);
            },
            compareWithoutThis(a, b) {
                let a_cp = Object.assign({}, a);
                let b_cp = Object.assign({}, b);

                if (a_cp.hasOwnProperty("this")) {
                    delete a_cp[a_cp['this']];
                    delete b_cp[a_cp['this']];
                    delete a_cp['this'];
                }

                if (b.hasOwnProperty("this")) {
                    delete b_cp[b_cp['this']];
                    delete a_cp[b_cp['this']];
                    delete b_cp['this'];
                }

                return this.compare(a_cp, b_cp);
            },
            compareThisValue(a, b) {
                let a_cp = Object.assign({}, a);
                let b_cp = Object.assign({}, b);

                let thisProperty = "";

                if (a_cp.hasOwnProperty("this")) {
                    thisProperty = a_cp['this'];
                }

                if (b.hasOwnProperty("this")) {
                    thisProperty = b_cp['this'];
                }


                for (let key in a_cp) {
                    if (key != thisProperty) {
                        delete a_cp[key];
                    }
                }

                for (let key in b_cp) {
                    if (key != thisProperty) {
                        delete b_cp[key];
                    }
                }

                return this.compare(a_cp, b_cp);
            },
            getActiveFunVoltages() {
                if (this.$store.state.activeFun && this.$store.state.activeFun.data && this.$store.state.activeFun.data.network_frequency && this.$store.state.activeFun.engine) {
                    let frequency = this.$fanObjParamsManager.GetSelectedElementOfOption(this.$store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

                    let voltage = this.$store.state.activeFun.engine['voltage_' + frequency + '_hz'];

                    if (voltage) {
                        let voltages = voltage.split("/");

                        return voltages;
                    }
                }

                return [];
            }

        },


        mounted() {
            let selectedWorkPointBaseFrequency = null;

            for(let optionId in this.$store.state.fourthStepParametersSelected.network_frequency.options){
              let currentOption = this.$store.state.fourthStepParametersSelected.network_frequency.options[optionId];

              if(currentOption.name == "workPointBaseFrequency"){
                for(let elementId in currentOption.elements){
                  let currentOptionElement = currentOption.elements[elementId];

                  if(currentOptionElement.active)
                    selectedWorkPointBaseFrequency = currentOptionElement.value;
                }
              }
            }

            if(!selectedWorkPointBaseFrequency)
              console.error("Problem ze znalezieniem parametru workPointBaseFrequency!!!");

            this.$root.$on('disabledCadTable', () => {
                this.cadHeaderVisible = false;
            })

            this.activeFanCount = this.$store.state.activeFun.count;
            this.$store.state.activeFun.count = 1;

            this.obiekt = measurementShow;
            window.measurementShow = this.obiekt;

            if (this.$store.state.activeFun && this.$store.state.workPointParameters.elements['work_frequency'] && this.$store.state.workPointParameters.elements['work_frequency'].value)
                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.$store.state.workPointParameters.elements['work_frequency'].value;
            else
                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.$store.state.fourthStepParameters['workPointFrequency'].value;

            if (this.$store.state.selectedFan && this.$store.state.selectedFan.engine_rpm) {
                this.$store.state.fourthStepParametersSelected['workPointRotationSpeed'].value = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value / 50 * parseFloat(this.$store.state.selectedFan.engine_rpm);
            }
            
            this.obiekt.data.workPointBaseFrequency = selectedWorkPointBaseFrequency;

            let selectedGraphs = null;
            if (this.offerView) {
                selectedGraphs = ['Noise'];
                if (this.$store.state.fourthStepParametersSelected.pressure.options[0].elements[0].active) {
                    selectedGraphs.push('TotalPressure');
                } else {
                    selectedGraphs.push('StaticPressure');
                }

                if (this.$store.state.fourthStepParametersSelected.material_amount.value != 0) {
                    selectedGraphs.push('PowerOnShaftWithMaterial');
                } else {
                    selectedGraphs.push('PowerOnShaft');
                }
            }

            this.obiekt.init(this.$store, selectedGraphs);
            let voltages = this.getActiveFunVoltages();

            if (voltages[0]) {
                this.obiekt.graphsObj.fanRecalced.lines["Amperage"].voltage = voltages[0];
                this.obiekt.graphsObj.fanRecalced.lines["Amperage"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;
                this.obiekt.graphsObj.fanRecalced.lines["Amperage"].engine_power_factor = this.$store.state.activeFun.engine.power_factor;

                this.obiekt.graphsObj.fan.lines["Amperage"].voltage = voltages[0];
                this.obiekt.graphsObj.fan.lines["Amperage"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;
                this.obiekt.graphsObj.fan.lines["Amperage"].engine_power_factor = this.$store.state.activeFun.engine.power_factor;
            }

            if (voltages[1]) {
                this.obiekt.graphsObj.fanRecalced.lines["AmperageV2"].voltage = voltages[1];
                this.obiekt.graphsObj.fanRecalced.lines["AmperageV2"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;
                this.obiekt.graphsObj.fanRecalced.lines["AmperageV2"].engine_power_factor = this.$store.state.activeFun.engine.power_factor;

                this.obiekt.graphsObj.fan.lines["AmperageV2"].voltage = voltages[1];
                this.obiekt.graphsObj.fan.lines["AmperageV2"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;
                this.obiekt.graphsObj.fan.lines["AmperageV2"].engine_power_factor = this.$store.state.activeFun.engine.power_factor;
            }

            this.obiekt.graphsObj.fanRecalced.lines["ElectricalPower"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;
            this.obiekt.graphsObj.fan.lines["ElectricalPower"].engine_efficiency_3_4 = this.$store.state.activeFun.engine.efficiency_3_4;

            this.obiekt.refreshAllData(this.$store.state.activeFun.params.work_frequency);

            this.obiekt.data.workPointBaseFrequency = selectedWorkPointBaseFrequency;

            this.obiekt.calc();
            this.obiekt.graphsSummary.draw();

            this.frequencyLock = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value;

            if (this.$store.state.selectedWorkPoint) {
                this.obiekt.graphsSummary.data.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                this.obiekt.graphsSummary.data.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                this.obiekt.graphsSummary.data.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;

                this.obiekt.graphsObj.data.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                this.obiekt.graphsObj.data.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                this.obiekt.graphsObj.data.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;

                this.obiekt.graphsSummary.changed.call(this);
            }
        },

        beforeDestroy() {
            this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.frequencyLock;
            this.$store.state.workPointParameters.elements['work_frequency'].value = this.frequencyLock;
            this.$store.state.activeFun.count = this.activeFanCount;

            this.$root.$off('disabledCatTable');
        }
    }
</script>